export const headCells = [
    {id: 'numeroDiTelefono', label: 'Numero di telefono', width: "20%"},
    {id: 'numeroSeriale', label: 'N. Seriale', width: "20%"},
    {id: 'statoSim', label: 'Stato SIM', width: "10%"},
    {id: 'dataInvio', label: 'Data Invio', width: "15%"},
    {id: 'emailInviata', label: 'email Inviata', width: "15%"},
    {id: 'tags', label: '', width: "20%"},
];
